import PageHeader from "../../../components/PageHeader";
import PageActions from "../../../components/PageActions";
import Table from "../../../components/Table";
import FilterModal from "../../../components/FilterModal";

import { aguardandoEntregaFilterFields } from "../constants/filterFields";
import { buildAguardandoEntregaTableRows } from "../utils/formatDisplay";
import { useAguardandoEntregaPage } from "../context/AguardandoEntregaContext";

const AguardandoEntregaContent = () => {
  const {
    filters,
    filterErrors,
    isFilterModalOpen,
    setIsFilterModalOpen,
    items,
    total,
    isInitialLoading,
    isRefetching,
    handleFieldChange,
    handleSearch,
    handleClear,
    clearFilterErrors,
  } = useAguardandoEntregaPage();

  const activeFiltersCount = Object.values(filters).filter(
    (value) => value !== null && value !== undefined && value !== ""
  ).length;

  const filterFields = aguardandoEntregaFilterFields.map((field) => ({
    ...field,
    value: filters[field.name as keyof typeof filters] || "",
  }));

  const tableData = buildAguardandoEntregaTableRows(items);

  return (
    <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <div className="mb-6 mt-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <PageHeader
          title="Aguardando Entrega"
          description="Pedidos finalizados no forno (delivery) aguardando ser entregues."
        />
        <PageActions
          onFilter={() => setIsFilterModalOpen(true)}
          onAdd={() => {}}
          addButtonText=""
          activeFiltersCount={activeFiltersCount}
          showAddButton={false}
        />
      </div>

      <FilterModal
        isOpen={isFilterModalOpen}
        onClose={() => {
          clearFilterErrors();
          setIsFilterModalOpen(false);
        }}
        fields={filterFields}
        errors={filterErrors}
        onFieldChange={handleFieldChange}
        onSearch={() => {
          if (handleSearch()) setIsFilterModalOpen(false);
        }}
        onClear={handleClear}
        gridClassName="grid grid-cols-2 gap-4"
      />

      <div className="mb-4 rounded-lg bg-white p-4 shadow">
        <p className="text-sm text-neutral-500">Total aguardando</p>
        <p className="text-2xl font-bold text-primary">
          {isInitialLoading ? "-" : total}
        </p>
        {isRefetching && (
          <p className="mt-1 text-xs text-neutral-400">Atualizando…</p>
        )}
      </div>

      <div className="rounded-lg bg-white p-4 shadow">
        <Table
          headers={[
            "Pedido",
            "Montador",
            "Saída do forno",
            "Cliente",
            "Observação",
          ]}
          data={tableData}
        />
        {isInitialLoading && (
          <div className="mt-3 text-sm text-neutral-500">
            Carregando aguardando entrega...
          </div>
        )}
        {!isInitialLoading && items.length === 0 && (
          <div className="mt-4 text-center text-neutral-500">
            Nenhum pedido aguardando entrega no momento.
          </div>
        )}
      </div>
    </main>
  );
};

export default AguardandoEntregaContent;
